import { render, staticRenderFns } from "./PlatformViewTeams.vue?vue&type=template&id=0f9f8e48&scoped=true&"
import script from "./PlatformViewTeams.vue?vue&type=script&lang=js&"
export * from "./PlatformViewTeams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9f8e48",
  null
  
)

export default component.exports